import React, {
  forwardRef,
  useImperativeHandle,
  useRef,
  useState,
} from "react";

import { Button } from "@chakra-ui/react";
import { ReactComponent as ChevronDownIcon } from "assets/icons/chevron-down-grey.svg";
import { Maybe } from "utils/general/maybe";

import { DropDownPopUp } from "./dropdown-popup";
import { IDropDownPopUpRef } from "./dropdown-popup/types";
import { dropdownButtonCss } from "./styles";
import { IDropDownRef, IDropdownProps } from "./types";

export const DropDown = forwardRef<IDropDownRef, IDropdownProps>(
  (props, ref) => {
    const {
      children,
      dropDownWidth,
      allowOutSideClick,
      dropDownBtnValue,
      dropDownBtnContent,
      hasChevronDownIcon,
      customDropDownButtonCss,
      className,
      dropDownPopUpMenuContentCss,
      dropDownPopUpMenuContentClassName,
      isDisabled,
      dropDownPopUpTopPosition,
      dropDownOverlayClassName,
    } = props;
    const [dropDownPopUpPosition, setDropDownPopUpPosition] = useState({
      top: 0,
      left: 0,
    });
    const dropDownBtnRef = useRef<HTMLButtonElement | null>(null);
    const dropDownPopUpRef = useRef<IDropDownPopUpRef>(null);

    const handleToggleDropdown = () => {
      if (!dropDownPopUpRef.current || !dropDownBtnRef.current) return;

      const rect = dropDownBtnRef.current.getBoundingClientRect();
      setDropDownPopUpPosition({
        top: rect.top + rect.height,
        left: rect.left + rect.width - dropDownWidth,
      });
      dropDownPopUpRef.current.handleToggleDropdown();
    };

    useImperativeHandle(ref, () => ({
      isDropDownOpen: dropDownPopUpRef.current?.isDropDownOpen || false,
      handleToggleDropdown,
      dropDownBtnRef,
    }));

    return (
      <>
        <Button
          className={`${className ? className : ""} drop-down-button`}
          css={{ ...dropdownButtonCss, ...customDropDownButtonCss }}
          ref={!isDisabled ? dropDownBtnRef : null}
          onClick={handleToggleDropdown}
        >
          <Maybe condition={!!dropDownBtnValue}>{dropDownBtnValue}</Maybe>
          <Maybe condition={!!dropDownBtnContent}>{dropDownBtnContent}</Maybe>
          <Maybe condition={!!hasChevronDownIcon}>
            <ChevronDownIcon className="w-4 h-4" />
          </Maybe>
        </Button>
        <DropDownPopUp
          ref={dropDownPopUpRef}
          dropDownBtnRef={dropDownBtnRef}
          dropDownWidth={dropDownWidth}
          position={dropDownPopUpPosition}
          dropDownPopUpMenuContentCss={dropDownPopUpMenuContentCss}
          dropDownPopUpMenuContentClassName={dropDownPopUpMenuContentClassName}
          allowOutSideClick={allowOutSideClick}
          dropDownPopUpTopPosition={dropDownPopUpTopPosition}
          dropDownOverlayClassName={dropDownOverlayClassName}
        >
          {children}
        </DropDownPopUp>
      </>
    );
  }
);
